import { QueryKeys } from '@frontend/features/common/types';

/**
 * Identidad de la ficha de un circuito. Vive en su propio módulo —como
 * `connectorCapabilitiesQueryKey`— porque la usan el hook (`queries.ts`) y los
 * tests, y meterla en `circuits.ts` cerraría un ciclo de imports con `queries`.
 *
 * El `productRef` del catálogo es PROVIDER-SCOPED (lo dice el contrato del
 * hub): dos proveedores pueden publicar el mismo ref y son productos
 * distintos. Por eso el proveedor entra en la identidad de la query — sin él,
 * abrir la ficha de uno serviría del cache la del otro — y viaja como filtro al
 * backend, que acota a quién se le pregunta.
 */
export function circuitProductQueryKey(
  agencyId: number,
  productRef?: string,
  provider?: string,
) {
  return [
    QueryKeys.getRuteroCatalog,
    'circuits',
    'product',
    agencyId,
    productRef,
    provider,
  ] as const;
}

/**
 * El path de la ficha. El ref va SIEMPRE encodeado (es opaco: hoy VPT trae
 * ":"), y el proveedor viaja como filtro cuando se sabe cuál es.
 */
export function circuitProductPath(productRef?: string, provider?: string) {
  const path = `rutero/circuits/products/${encodeURIComponent(productRef ?? '')}`;
  return provider ? `${path}?provider=${encodeURIComponent(provider)}` : path;
}
